import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "manage-exams-view" }
const _hoisted_2 = { key: "list-view" }
const _hoisted_3 = {
  key: 0,
  class: "mt-6 flex flex-col justify-center items-center py-12"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6"
}
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "text-red-700 dark:text-red-300 font-medium" }
const _hoisted_7 = {
  key: 2,
  class: "space-y-6"
}
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_9 = { class: "flex items-center mb-4" }
const _hoisted_10 = { class: "w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mr-4" }
const _hoisted_11 = { class: "card p-6 border-2 border-transparent" }
const _hoisted_12 = { class: "flex items-center mb-4" }
const _hoisted_13 = { class: "w-10 h-10 rounded-lg bg-green-100 dark:bg-green-900/30 flex items-center justify-center mr-4" }
const _hoisted_14 = {
  class: "card p-6 hover:shadow-md transition-shadow cursor-pointer border-2 border-transparent hover:border-purple-200 dark:hover:border-purple-800",
  style: {"height":"100%"}
}
const _hoisted_15 = { class: "flex items-center mb-4" }
const _hoisted_16 = { class: "w-10 h-10 rounded-lg bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center mr-4" }
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-4 gap-6" }
const _hoisted_18 = { class: "card p-6" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "flex-shrink-0" }
const _hoisted_21 = { class: "ml-4" }
const _hoisted_22 = { class: "text-2xl font-bold text-primary-text dark:text-primary-dark-text" }
const _hoisted_23 = { class: "card p-6" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "flex-shrink-0" }
const _hoisted_26 = { class: "ml-4" }
const _hoisted_27 = { class: "text-2xl font-bold text-primary-text dark:text-primary-dark-text" }
const _hoisted_28 = { class: "card p-6" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "flex-shrink-0" }
const _hoisted_31 = { class: "ml-4" }
const _hoisted_32 = { class: "text-2xl font-bold text-primary-text dark:text-primary-dark-text" }
const _hoisted_33 = { class: "card p-6" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "flex-shrink-0" }
const _hoisted_36 = { class: "ml-4" }
const _hoisted_37 = { class: "text-2xl font-bold text-primary-text dark:text-primary-dark-text" }
const _hoisted_38 = ["onChange"]
const _hoisted_39 = { class: "text-sm font-medium text-primary-text dark:text-primary-dark-text" }
const _hoisted_40 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_41 = {
  key: 0,
  class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300"
}
const _hoisted_42 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_43 = { class: "flex justify-center" }
const _hoisted_44 = { class: "flex justify-center space-x-3" }
const _hoisted_45 = ["onClick", "title"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "flex gap-2" }
const _hoisted_50 = ["onClick", "title"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300"
}
const _hoisted_55 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_56 = { class: "bg-white dark:bg-gray-800 rounded-lg p-4 shadow border border-gray-200 dark:border-gray-700" }
const _hoisted_57 = { class: "flex items-start justify-between mb-3" }
const _hoisted_58 = { class: "flex-1" }
const _hoisted_59 = { class: "text-lg font-medium text-primary-text dark:text-primary-dark-text mb-1" }
const _hoisted_60 = { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }
const _hoisted_61 = { class: "mb-3" }
const _hoisted_62 = {
  key: 0,
  class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300"
}
const _hoisted_63 = {
  key: 1,
  class: "text-gray-400 text-sm"
}
const _hoisted_64 = { class: "space-y-2 mb-4 text-sm" }
const _hoisted_65 = { class: "ml-2 text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "ml-2 text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_68 = { class: "ml-2 text-primary-text dark:text-primary-dark-text font-medium" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "flex justify-end space-x-2 pt-3 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_71 = ["onClick", "title"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "flex flex-col sm:flex-row gap-2 justify-center" }

import { ref, computed, onMounted, watch } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useToastService } from '@/services/toast'
import { examService } from '@/services/examService'
import { ModulesService } from '@/services/modules'
import type { Exam } from '@/services/examService'
import type { Module } from '@/services/modules'
import DataTable from '@/components/common/DataTable.vue'
import ViewExamContent from '@/components/modals/ViewExamContent.vue'
import CreateExamView from './CreateExamView.vue'
import EditExamView from './EditExamView.vue'
import DeleteExam from '@/components/modals/DeleteExam.vue'
import {
  ClipboardList,
  Plus,
  Upload,
  CheckCircle,
  Users,
  TrendingUp,
  BarChart3,
  AlertCircle,
  Edit,
  Eye,
  Trash2,
  Lock,
  LockOpen
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageExamsView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Empathy Health Services, Inc.')
const { setTitle } = useTitle(`Exams - ${appTitle.value}`)

const toastService = useToastService()

// Helper function to maintain backward compatibility
const showToast = (message: string, type: 'success' | 'error' | 'info' = 'info') => {
  if (type === 'success') {
    toastService.success(message)
  } else if (type === 'error') {
    toastService.error(message)
  } else {
    toastService.success(message) // Use success for info since the service may not have info
  }
}

// View state
const currentView = ref<'list' | 'create' | 'edit'>('list')
const loading = ref(false)
const error = ref('')

// Update document title when switching views
watch(currentView, (newView) => {
  if (newView === 'list') {
    setTitle(`Exams - ${appTitle.value}`)
  } else if (newView === 'create') {
    setTitle(`Create Exam - ${appTitle.value}`)
  } else if (newView === 'edit') {
    setTitle(`Edit Exam - ${appTitle.value}`)
  }
})

// Data with proper typing
const exams = ref<Exam[]>([])
const modules = ref<Module[]>([])

// DataTable configuration
const displayExams = computed(() => exams.value)

const tableColumns = [
  { key: 'exam_name', label: 'Exam Details', sortable: true },
  { key: 'module', label: 'Module', sortable: false },
  { key: 'questions', label: 'Questions', sortable: false },
  { key: 'duration', label: 'Duration', sortable: true },
  { key: 'status', label: 'Status', align: 'center' as const, sortable: true }
]

const sortableColumns = [
  { key: 'exam_name', label: 'Exam Name' },
  { key: 'created_at', label: 'Created Date' },
  { key: 'time_limit', label: 'Duration' },
  { key: 'exam_status', label: 'Status' }
]

const mobileColumns = [
  { key: 'exam_name', label: 'Name' },
  { key: 'module', label: 'Module' },
  { key: 'status', label: 'Status' }
]

// Load filter state from localStorage
const loadFilterState = () => {
  try {
    const savedFilter = localStorage.getItem('manageExamsStatusFilter')
    return savedFilter || ''
  } catch (error) {
    console.error('Failed to load filter state from localStorage:', error)
    return ''
  }
}

// Save filter state to localStorage
const saveFilterState = (value: string) => {
  try {
    localStorage.setItem('manageExamsStatusFilter', value)
  } catch (error) {
    console.error('Failed to save filter state to localStorage:', error)
  }
}

// Filtering and search state - initialize from localStorage
const statusFilter = ref(loadFilterState())

// Watch for status filter changes and save to localStorage
watch(statusFilter, (newValue) => {
  saveFilterState(newValue)
})

// Check if any filters are active
const hasActiveFilters = computed(() => {
  return statusFilter.value !== ''
})

// Computed properties
const totalExams = computed(() => exams.value.length)
const activeExams = computed(() => exams.value.filter((exam: Exam) => exam.exam_status === 1).length)
const draftExams = computed(() => exams.value.filter((exam: Exam) => exam.exam_status === 0).length)
const averageQuestions = computed(() => {
  if (exams.value.length === 0) return 0
  const totalQuestions = exams.value.reduce((sum: number, exam: Exam) => sum + (exam.exam_content?.questions?.length || 0), 0)
  return Math.round(totalQuestions / exams.value.length)
})

// Methods
const fetchExams = async () => {
  try {
    loading.value = true
    error.value = ''
    const response = await examService.getAllExams()
    console.log('Raw API response:', response)
    
    // The API returns: { success: true, data: { data: [exams], ...pagination } }
    // So we need to access response.data.data.data for the actual exam array
    const examData = response.data?.data?.data || []
    console.log('Extracted exam data:', examData)
    
    exams.value = Array.isArray(examData) ? examData : []
    console.log('Final exams array:', exams.value)
  } catch (err: any) {
    console.error('Error fetching exams:', err)
    error.value = err.response?.data?.message || err.message || 'Failed to load exams'
    exams.value = [] // Ensure exams is always an array
    showToast('Failed to load exams', 'error')
  } finally {
    loading.value = false
  }
}

const fetchModules = async () => {
  try {
    const moduleData = await ModulesService.getModules()
    modules.value = Array.isArray(moduleData) ? moduleData : []
  } catch (err: any) {
    console.error('Error fetching modules:', err)
    modules.value = []
  }
}

// DataTable event handlers
const handleSearch = (query: string) => {
  // The DataTable component handles search internally
  console.log('Search query:', query)
}

const handleSort = (sort: { field: string, direction: 'asc' | 'desc' }) => {
  // The DataTable component handles sorting internally
  console.log('Sort config:', sort)
}

const handleFilter = (filters: Record<string, any>) => {
  // The DataTable component handles filtering internally
  console.log('Filters applied:', filters)
}

const handlePageChange = (page: number) => {
  // The DataTable component handles pagination internally
  console.log('Page changed to:', page)
}

const handleItemsPerPageChange = (itemsPerPage: number) => {
  // The DataTable component handles items per page internally
  console.log('Items per page changed to:', itemsPerPage)
}

const clearAllFilters = () => {
  statusFilter.value = ''
}

// Exam actions
const showViewModal = ref(false)
const selectedExam = ref<Exam | null>(null)
const selectedExamId = ref<number>(0)

const toggleExamStatus = async (exam: any) => {
  try {
    const newStatus = exam.exam_status === 1 ? 0 : 1
    await examService.updateExamStatus(exam.exam_id, newStatus)
    exam.exam_status = newStatus
    showToast(`Exam ${newStatus === 1 ? 'activated' : 'drafted'} successfully!`, 'success')
  } catch (err: any) {
    console.error('Error updating exam status:', err)
    showToast(err.response?.data?.message || 'Failed to update exam status', 'error')
  }
}

const editExam = (exam: Exam) => {
  selectedExamId.value = exam.exam_id
  currentView.value = 'edit'
}

const viewExam = (exam: Exam) => {
  selectedExam.value = exam
  showViewModal.value = true
}

// Delete Exam
const showDeleteModal = ref(false)
const examToDelete = ref<Exam | null>(null)

const deleteExam = (exam: Exam) => {
  examToDelete.value = exam
  showDeleteModal.value = true
}

const onExamDeleted = async () => {
  showDeleteModal.value = false
  examToDelete.value = null
  await fetchExams()
}

const closeDeleteModal = () => {
  showDeleteModal.value = false
  setTimeout(() => {
    examToDelete.value = null
  }, 300)
}

const formatDate = (dateString: string) => {
  if (!dateString) return 'Unknown'
  
  const date = new Date(dateString)
  const now = new Date()
  const diffInMs = now.getTime() - date.getTime()
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
  
  if (diffInDays === 0) return 'Today'
  if (diffInDays === 1) return 'Yesterday'
  if (diffInDays < 7) return `${diffInDays} days ago`
  if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} weeks ago`
  if (diffInDays < 365) return `${Math.floor(diffInDays / 30)} months ago`
  return `${Math.floor(diffInDays / 365)} years ago`
}

// Format module display name as MMYY-HHA-[Module Title]
const formatModuleName = (module: any): string => {
  const name = module?.name || ''
  // Remove "Module X -" prefix if present
  const cleanedName = name.replace(/^Module\s+\d+\s*[-:\s]\s*/i, '').trim()

  // Try multiple date fields to find a valid date for MMYY prefix
  const candidateDates = [
    module?.time_setting?.start_date,
    module?.access_date_start,
    module?.added_at,
    module?.created_at
  ]

  const dateStr = candidateDates.find(d => d)
  if (!dateStr) return cleanedName

  try {
    const startDate = new Date(dateStr)
    if (Number.isNaN(startDate.getTime())) return cleanedName

    const month = String(startDate.getMonth() + 1).padStart(2, '0')
    const year = String(startDate.getFullYear()).slice(-2)
    return `${month}${year}-HHA-${cleanedName}`
  } catch {
    return cleanedName
  }
}

// Lifecycle
onMounted(() => {
  fetchExams()
  fetchModules()
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "exam-view",
      mode: "out-in",
      "enter-active-class": "exam-view-enter-active",
      "leave-active-class": "exam-view-leave-active",
      "enter-from-class": "exam-view-enter-from",
      "leave-to-class": "exam-view-leave-to"
    }, {
      default: _withCtx(() => [
        (currentView.value === 'create')
          ? (_openBlock(), _createBlock(CreateExamView, {
              onBack: _cache[0] || (_cache[0] = ($event: any) => (currentView.value = 'list')),
              onExamCreated: fetchExams,
              key: "create-exam"
            }))
          : (currentView.value === 'edit' && selectedExamId.value > 0)
            ? (_openBlock(), _createBlock(EditExamView, {
                "exam-id": selectedExamId.value,
                onBack: _cache[1] || (_cache[1] = ($event: any) => (currentView.value = 'list')),
                onExamUpdated: fetchExams,
                key: "edit-exam"
              }, null, 8, ["exam-id"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "mb-6" }, [
                  _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-primary-text dark:text-primary-dark-text mb-2" }, " Manage Exams "),
                  _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Create, edit, and manage exam content and settings. ")
                ], -1)),
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-4" }, null, -1),
                      _createElementVNode("span", { class: "text-primary-text dark:text-primary-dark-text" }, "Loading exams...", -1)
                    ]))]))
                  : (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(AlertCircle), { class: "h-5 w-5 text-red-500 mr-2" }),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(error.value), 1)
                        ]),
                        _createElementVNode("button", {
                          onClick: fetchExams,
                          class: "mt-2 text-sm text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 underline"
                        }, " Try again ")
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (currentView.value = 'create')),
                            class: "card p-6 hover:shadow-md transition-shadow cursor-pointer border-2 border-transparent hover:border-blue-200 dark:hover:border-blue-800"
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_unref(Plus), { class: "w-6 h-6 text-blue-600 dark:text-blue-400" })
                              ]),
                              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }, " Create New Exam ", -1))
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text text-sm" }, " Design and create new examination content with custom questions and settings. ", -1))
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_unref(Upload), { class: "w-6 h-6 text-green-600 dark:text-green-400" })
                              ]),
                              _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }, " Edit Exam ", -1))
                            ]),
                            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text text-sm" }, " Select an exam from the list below to modify and update its content and settings. ", -1))
                          ]),
                          _createVNode(_component_router_link, {
                            to: "/exam-results",
                            class: "block"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_unref(BarChart3), { class: "w-6 h-6 text-purple-600 dark:text-purple-400" })
                                  ]),
                                  _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-lg font-semibold text-primary-text dark:text-primary-dark-text" }, " View Exam Results ", -1))
                                ]),
                                _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text text-sm" }, " Preview and review exam content and structure. ", -1))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_unref(ClipboardList), { class: "w-8 h-8 text-blue-500" })
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text" }, " Total Exams ", -1)),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(totalExams.value), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_unref(CheckCircle), { class: "w-8 h-8 text-green-500" })
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text" }, " Active Exams ", -1)),
                                _createElementVNode("p", _hoisted_27, _toDisplayString(activeExams.value), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_unref(Users), { class: "w-8 h-8 text-purple-500" })
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text" }, " Draft Exams ", -1)),
                                _createElementVNode("p", _hoisted_32, _toDisplayString(draftExams.value), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createVNode(_unref(TrendingUp), { class: "w-8 h-8 text-orange-500" })
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-sm font-medium text-secondary-text dark:text-secondary-dark-text" }, " Avg. Questions ", -1)),
                                _createElementVNode("p", _hoisted_37, _toDisplayString(averageQuestions.value), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createVNode(DataTable, {
                          data: displayExams.value,
                          columns: tableColumns,
                          loading: loading.value,
                          "sortable-columns": sortableColumns,
                          "mobile-columns": mobileColumns,
                          "item-key": "exam_id",
                          "item-label": "exams",
                          "search-placeholder": "Search exams...",
                          "summary-icon": _unref(ClipboardList),
                          "show-search": true,
                          "show-filters": true,
                          "show-pagination": true,
                          "show-summary": true,
                          "items-per-page": 15,
                          "items-per-page-options": [10, 15, 25, 50],
                          "table-id": "manage-exams-table",
                          onSearch: handleSearch,
                          onSort: handleSort,
                          onFilter: handleFilter,
                          onPageChange: handlePageChange,
                          onItemsPerPageChange: handleItemsPerPageChange
                        }, {
                          actions: _withCtx(() => [
                            _createElementVNode("button", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (currentView.value = 'create')),
                              class: "btn btn-primary btn-sm flex items-center gap-2"
                            }, [
                              _createVNode(_unref(Plus), { class: "h-4 w-4" }),
                              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "hidden sm:inline" }, "Create Exam", -1))
                            ])
                          ]),
                          filters: _withCtx(({ updateFilter }) => [
                            _createElementVNode("div", null, [
                              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Status ", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((statusFilter).value = $event)),
                                onChange: ($event: any) => (updateFilter('exam_status', statusFilter.value === '' ? '' : Number(statusFilter.value))),
                                class: "block w-full px-3 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200 shadow-sm hover:shadow-md"
                              }, [...(_cache[19] || (_cache[19] = [
                                _createElementVNode("option", { value: "" }, "All Status", -1),
                                _createElementVNode("option", { value: "1" }, "Active", -1),
                                _createElementVNode("option", { value: "0" }, "Draft", -1)
                              ]))], 40, _hoisted_38), [
                                [_vModelSelect, statusFilter.value]
                              ])
                            ])
                          ]),
                          "cell-exam_name": _withCtx(({ item }) => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_39, _toDisplayString(item.exam_name), 1),
                              _createElementVNode("div", _hoisted_40, " Created " + _toDisplayString(formatDate(item.created_at)), 1)
                            ])
                          ]),
                          "cell-module": _withCtx(({ item }) => [
                            (item.module)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(formatModuleName(item.module)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_42, "No module"))
                          ]),
                          "cell-questions": _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(item.exam_content?.questions?.length || 0), 1)
                          ]),
                          "cell-duration": _withCtx(({ item }) => [
                            _createTextVNode(_toDisplayString(item.time_limit ? `${item.time_limit} min` : 'No limit'), 1)
                          ]),
                          "cell-status": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                  'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                  item.exam_status === 1
                    ? 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'
                    : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100'
                ])
                              }, _toDisplayString(item.exam_status === 1 ? 'Active' : 'Draft'), 3)
                            ])
                          ]),
                          "row-actions": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("button", {
                                class: _normalizeClass([
                  'transition duration-200 transform',
                  item.exam_status === 1
                    ? 'text-orange-500 hover:text-orange-700'
                    : 'text-green-500 hover:text-green-700'
                ]),
                                onClick: ($event: any) => (toggleExamStatus(item)),
                                title: item.exam_status === 1 ? 'Deactivate Exam' : 'Activate Exam'
                              }, [
                                (item.exam_status === 1)
                                  ? (_openBlock(), _createBlock(_unref(LockOpen), {
                                      key: 0,
                                      class: "h-5 w-5"
                                    }))
                                  : (_openBlock(), _createBlock(_unref(Lock), {
                                      key: 1,
                                      class: "h-5 w-5"
                                    }))
                              ], 10, _hoisted_45),
                              _createElementVNode("button", {
                                class: "text-blue-500 hover:text-blue-700",
                                onClick: ($event: any) => (editExam(item)),
                                title: "Edit Exam"
                              }, [
                                _createVNode(_unref(Edit), { class: "h-5 w-5" })
                              ], 8, _hoisted_46),
                              _createElementVNode("button", {
                                class: "text-green-500 hover:text-green-700",
                                onClick: ($event: any) => (viewExam(item)),
                                title: "View Exam"
                              }, [
                                _createVNode(_unref(Eye), { class: "h-5 w-5" })
                              ], 8, _hoisted_47),
                              _createElementVNode("button", {
                                class: "text-red-500 hover:text-red-700",
                                onClick: ($event: any) => (deleteExam(item)),
                                title: "Delete Exam"
                              }, [
                                _createVNode(_unref(Trash2), { class: "h-5 w-5" })
                              ], 8, _hoisted_48)
                            ])
                          ]),
                          "mobile-actions": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (toggleExamStatus(item)),
                                class: _normalizeClass([
                  'p-2 rounded-lg transition-colors',
                  item.exam_status === 1
                    ? 'text-orange-500 hover:bg-orange-50 dark:hover:bg-orange-900/20'
                    : 'text-green-500 hover:bg-green-50 dark:hover:bg-green-900/20'
                ]),
                                title: item.exam_status === 1 ? 'Deactivate' : 'Activate'
                              }, [
                                (item.exam_status === 1)
                                  ? (_openBlock(), _createBlock(_unref(LockOpen), {
                                      key: 0,
                                      class: "h-4 w-4"
                                    }))
                                  : (_openBlock(), _createBlock(_unref(Lock), {
                                      key: 1,
                                      class: "h-4 w-4"
                                    }))
                              ], 10, _hoisted_50),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (editExam(item)),
                                class: "p-2 rounded-lg text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors",
                                title: "Edit"
                              }, [
                                _createVNode(_unref(Edit), { class: "h-4 w-4" })
                              ], 8, _hoisted_51),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (viewExam(item)),
                                class: "p-2 rounded-lg text-green-500 hover:bg-green-50 dark:hover:bg-green-900/20 transition-colors",
                                title: "View"
                              }, [
                                _createVNode(_unref(Eye), { class: "h-4 w-4" })
                              ], 8, _hoisted_52),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (deleteExam(item)),
                                class: "p-2 rounded-lg text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors",
                                title: "Delete"
                              }, [
                                _createVNode(_unref(Trash2), { class: "h-4 w-4" })
                              ], 8, _hoisted_53)
                            ])
                          ]),
                          "mobile-module": _withCtx(({ item }) => [
                            (item.module)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(item.module.name), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_55, "No module"))
                          ]),
                          "mobile-card": _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("h3", _hoisted_59, _toDisplayString(item.exam_name), 1),
                                  _createElementVNode("p", _hoisted_60, " Created " + _toDisplayString(formatDate(item.created_at)), 1)
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass([
                    'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                    item.exam_status === 1
                      ? 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'
                      : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100'
                  ])
                                }, _toDisplayString(item.exam_status === 1 ? 'Active' : 'Draft'), 3)
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                (item.module)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(item.module.name), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_63, "No module assigned"))
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", null, [
                                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Questions:", -1)),
                                  _createElementVNode("span", _hoisted_65, _toDisplayString(item.exam_content?.questions?.length || 0), 1)
                                ]),
                                (item.passing_rate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Pass Rate:", -1)),
                                      _createElementVNode("span", _hoisted_67, _toDisplayString(item.passing_rate) + "%", 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Duration:", -1)),
                                  _createElementVNode("span", _hoisted_68, _toDisplayString(item.time_limit ? `${item.time_limit} min` : 'No limit'), 1)
                                ]),
                                (item.exam_content?.instructions)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [...(_cache[24] || (_cache[24] = [
                                      _createElementVNode("span", { class: "text-secondary-text dark:text-secondary-dark-text" }, "Instructions:", -1),
                                      _createElementVNode("span", { class: "ml-2 text-primary-text dark:text-primary-dark-text font-medium" }, "Available", -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (toggleExamStatus(item)),
                                  class: _normalizeClass([
                    'p-2 rounded-lg transition-colors',
                    item.exam_status === 1
                      ? 'text-orange-500 hover:bg-orange-50 dark:hover:bg-orange-900/20'
                      : 'text-green-500 hover:bg-green-50 dark:hover:bg-green-900/20'
                  ]),
                                  title: item.exam_status === 1 ? 'Deactivate' : 'Activate'
                                }, [
                                  (item.exam_status === 1)
                                    ? (_openBlock(), _createBlock(_unref(LockOpen), {
                                        key: 0,
                                        class: "h-4 w-4"
                                      }))
                                    : (_openBlock(), _createBlock(_unref(Lock), {
                                        key: 1,
                                        class: "h-4 w-4"
                                      }))
                                ], 10, _hoisted_71),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (editExam(item)),
                                  class: "p-2 rounded-lg text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors",
                                  title: "Edit"
                                }, [
                                  _createVNode(_unref(Edit), { class: "h-4 w-4" })
                                ], 8, _hoisted_72),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (viewExam(item)),
                                  class: "p-2 rounded-lg text-green-500 hover:bg-green-50 dark:hover:bg-green-900/20 transition-colors",
                                  title: "View"
                                }, [
                                  _createVNode(_unref(Eye), { class: "h-4 w-4" })
                                ], 8, _hoisted_73),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (deleteExam(item)),
                                  class: "p-2 rounded-lg text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors",
                                  title: "Delete"
                                }, [
                                  _createVNode(_unref(Trash2), { class: "h-4 w-4" })
                                ], 8, _hoisted_74)
                              ])
                            ])
                          ]),
                          "empty-actions": _withCtx(() => [
                            _createElementVNode("div", _hoisted_75, [
                              (hasActiveFilters.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: clearAllFilters,
                                    class: "btn btn-secondary btn-sm"
                                  }, " Clear Filters "))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (currentView.value = 'create')),
                                class: "btn btn-primary btn-sm"
                              }, " Create First Exam ")
                            ])
                          ]),
                          _: 1
                        }, 8, ["data", "loading", "summary-icon"])
                      ]))
              ]))
      ]),
      _: 1
    }),
    _createVNode(ViewExamContent, {
      "is-visible": showViewModal.value,
      exam: selectedExam.value,
      modules: modules.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (showViewModal.value = false))
    }, null, 8, ["is-visible", "exam", "modules"]),
    (examToDelete.value)
      ? (_openBlock(), _createBlock(DeleteExam, {
          key: 0,
          "is-visible": showDeleteModal.value,
          exam: examToDelete.value,
          onSuccess: onExamDeleted,
          onClose: closeDeleteModal
        }, null, 8, ["is-visible", "exam"]))
      : _createCommentVNode("", true)
  ]))
}
}

})